<template>
	<div class="dashboard">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Export Stock Adjustment</h1>
		<div class="content-wrapper">
			<b-field label="Select Shop (required)">
				<b-autocomplete
					v-model="shopsSuggestions"
					:data="filteredShops"
					:open-on-focus="true"
					placeholder="Shop"
					field="name"
					@select="option => (selectedShop = option)"
					class="shopAutoComplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field>

			<div class="datepickerWrapper">
				<b-field label="Starting Date">
					<b-datepicker :date-formatter="dateFormatter" placeholder="Click to select..." v-model="startingDate" icon="calendar-today">
						<button class="button is-primary" @click="startingDate = new Date()">
							<b-icon icon="calendar-today"></b-icon>
							<span>Today</span>
						</button>

						<button class="button is-danger" @click="startingDate = null">
							<b-icon icon="close"></b-icon>
							<span>Clear</span>
						</button></b-datepicker
					>
				</b-field>

				<b-field label="Ending Date">
					<b-datepicker
						:date-formatter="dateFormatter"
						placeholder="Click to select..."
						v-model="endingDate"
						icon="calendar-today"
						:min-date="minDate"
					>
						<button class="button is-danger" @click="endingDate = null">
							<b-icon icon="close"></b-icon>
							<span>Clear</span>
						</button></b-datepicker
					>
				</b-field>
			</div>

			<div class="filter-button-wrapper">
				<div class="big-button" @click="submit()">EXPORT</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Dashboard',
	data: () => ({
		limit: 20,
		isLoading: false,
		startingDate: null,
		endingDate: null,
		minDate: null,
		shops: [], // For list of shops from API
		shopsSuggestions: '', // For dropdown selection
		selectedShop: null, // Selected shop
		histories: []
	}),

	watch: {
		startingDate: function(data) {
			if (data !== null) {
				this.minDate = data
				// this.maxDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 30)

				this.endingDate = data
			} else {
				this.endingDate = null
			}
		}
	},

	mounted: async function() {
		await this.getShops()
	},

	computed: {
		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	methods: {
		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		},

		submit: async function() {
			if (this.selectedShop == null || this.startingDate == null || this.endingDate == null) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'All the fields are required'
				})

				return
			}

			this.histories = []
			this.isLoading = true

			var data = {}
			const createdAt = {}

			if (this.startingDate !== null) {
				createdAt['$gte'] = this.$moment(this.startingDate)
					.set({ hour: 0 })
					.format('x')
			}

			if (this.endingDate !== null) {
				createdAt['$lte'] = this.$moment(this.endingDate)
					.set({ hour: 24 })
					.format('x')
			}

			// For getting total value of sales
			data = {
				limit: this.limit,
				skip: 0,
				time: {
					createdAt
				}
			}

			if (this.selectedShop && this.selectedShop._id) {
				data.shop_product = {}
				data.shop_product.shop = this.selectedShop._id
			}

			const result = await this.$api.shopProductHistory({ data })

			if (result && result.data.count > 0) {
				result.data.list.map(item => {
					this.histories.push(item)
				})
			}

			if (result.data.total > this.limit) {
				let totalLoop = Math.ceil(result.data.total / this.limit)

				if (totalLoop > 1) {
					var i

					for (i = 1; i < totalLoop; i++) {
						const skip = i * this.limit

						data.skip = skip

						const result = await this.$api.shopProductHistory({ data })

						if (result && result.data.count > 0) {
							result.data.list.map(item => {
								this.histories.push(item)
							})
						}
					}
				}
			}

			if (this.histories.length > 0) {
				this.histories.map(history => {
					console.log(history)
				})
			}

			this.isLoading = false
		},

		getSales: async function() {
			const data = {}

			const apiGetSales = await this.$api.getSales({ data })
			if (apiGetSales !== undefined) {
				this.totalSales = apiGetSales.data[0]
			}
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
